import React from 'react';

import {CircularProgress, Modal, ModalClose, ModalDialog, Stack} from "@mui/joy";
import Button from "@mui/joy/Button";

// components
import BaseApi from "../../utils/BaseApi";
import Box from "@mui/joy/Box";
import MessageCommonAttachment from "./MessageCommonAttachment";


class MessagePDF extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            content: null,
            modalOpen: false
        }
    }

    async componentDidMount() {
    }

    async retrieveContent(){
        let url
        if (['doc', 'docx'].includes(this.props.message.extension)){
             url = `message/${this.props.message.id}/convert_to_pdf`;
        }
        else {
             url = `message/${this.props.message.id}/download`;
        }
        const api = new BaseApi();
        let params = {};
        let response = await api.get(
            url,
            params
        );
        this.setState({
            content: response.data.content
        }, () => {
            this.setState({
                modalOpen: true
            })
        })
    }

    render() {
        return (
            <Stack
                spacing={1}
            >
                <MessageCommonAttachment
                    message={this.props.message}
                />
                <Button
                    onClick={this.retrieveContent.bind(this)}
                >
                    Открыть здесь
                </Button>
                <Modal
                    open={this.state.modalOpen}
                >
                    <ModalDialog
                        layout={'center'}
                        size="sm"
                    >
                        <ModalClose
                            onClick={() => {
                                this.setState({
                                    modalOpen: false
                                })
                            }}
                        />
                        <Box
                            sx={{
                                width: 'calc(80vw)',
                                height: 'calc(80vh)',
                                pr: 2
                            }}
                        >
                            <iframe
                                src={`data:application/pdf;base64,${this.state.content}`}
                                width="100%"
                                height="100%"
                                title="PDF Preview"
                                style={{
                                    border: 'none'
                                }}
                            />
                        </Box>
                    </ModalDialog>
                </Modal>
            </Stack>
        )
    }
}

export default MessagePDF
